import { getStorage } from "@-/dev.improve.haniverse.lib.storage";

const STORAGE_KEY_PREFIX = "analytics.currentLevelIndex.";

/** Sentinel stored once every level is done (`findCurrentLevelIndex` → `null`). */
const ALL_LEVELS_DONE = Number.MAX_SAFE_INTEGER;

/**
 * Advances the learner's highest-seen current level and returns the indexes of levels completed
 * since the last observation. The first observation for an identity only seeds the mark, so an
 * existing learner's history is not replayed as fresh completions.
 */
export function advanceLevelHighWaterMark({
  currentLevelIndex,
  distinctId,
  levelIndexes,
}: {
  currentLevelIndex: number | null;
  distinctId: string;
  levelIndexes: readonly number[];
}): number[] {
  const key = STORAGE_KEY_PREFIX + distinctId;
  const current = currentLevelIndex ?? ALL_LEVELS_DONE;
  const previous = getStorage().getNumber(key);
  if (previous === undefined) {
    getStorage().set(key, current);
    return [];
  }
  if (current <= previous) {
    return [];
  }
  getStorage().set(key, current);
  return levelIndexes.filter((index) => index >= previous && index < current);
}
